import React from "react";
import boiler from "../../static/Icons/boiler.png";
import pipe from "../../static/Icons/pipe.png";
import spanner from "../assets/Icons/spanner.png";
import plantroom from "../assets/Icons/plant-room.png";
import certificate from "../assets/Icons/certificate.png";
import "../assets/css/App.css";
import "../assets/css/index.css";
import "../assets/css/Section.css";
import "../assets/css/Home.css";
import { Link } from "gatsby";
import { Row, Col } from "react-bootstrap";

export const ServicesBlock2 = () => {
  return (
    <div>
    <Row>
            <Col md className="home-button">
              <Link to="/commercial-boiler-repair/">
                <img
                  alt="Image of boiler"
                  class="pb-4 mx-auto d-block home-icon"
                  src={boiler}
                />
                <h3 class="heading-color text-center">
                  Commercial boiler repair
                </h3>
                <p class="text-center normal-text-colour">
                  It’s vital to service your commercial boiler regularly to keep it
                  running safely and efficiently. Have your London commercial boiler
                  serviced before winter so we can highlight and fix any potential
                  problems before it’s too late.
                </p>
              </Link>
            </Col>
            <Col md className="home-button">
              <Link to="/commercial-plant-room-installation-london/" className="home-icon">
                <img
                  alt="Image of spanner"
                  class="pb-4 mx-auto d-block home-icon"
                  src={plantroom}
                />
                <h3 class="heading-color text-center">Plant Room Installation</h3>
                <p class="text-center normal-text-colour">It’s crucial to have a working plant room in your commercial building to ensure it operates smoothly and efficiently. Whether you’re installing a new plant room or upgrading your existing one, we can help you design a plant room that makes servicing easier and lowers energy bills.
                </p>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col md className="home-button">
              <Link to="/commercial-boiler-installations/">
                <img
                  alt="Image of pipes"
                  class="pb-4 mx-auto d-block home-icon"
                  src={pipe}
                />
                <h3 class="heading-color text-center">
                  Commercial boiler installation
                </h3>
                <p class="text-center normal-text-colour">
                  Is your commercial boiler old and inefficient? It could cost your
                  business money as it must work harder to run. If you’re having
                  regular breakdowns that need repairs it might be time for a new
                  boiler. We can guide you through the process and help you find the
                  best commercial boiler for your London premises.
                </p>
              </Link>
            </Col>
            <Col md className="home-button">
              <Link to="/commercial-gas-safety-check/" className="home-icon">
                <img
                  alt="Image of spanner"
                  class="pb-4 mx-auto d-block home-icon"
                  src={certificate}
                />
                <h3 class="heading-color text-center">Gas Safety certificates</h3>
                <p class="text-center normal-text-colour">
                  Whether you’re a landlord with properties in London or you have
                  commercial premises, we’ll carry out a Gas Safety check and issue
                  you with a Gas Safety certificate. Keep your tenants, staff and
                  customers safe by having a Gas Safe registered engineer check that
                  your commercial heating systems are working correctly.
                </p>
              </Link>
            </Col>
          </Row>
          </div>
  );
};
